import React, { useEffect, useState } from "react";
import { useUser } from "../../../../hooks/use-user";
import { Share2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

function ContestButton({
  startTimeON,
  endTimeON,
  contestId,
  handleContestPayments,
  isContestSubmitted,
}) {
  const { data: user } = useUser();
  const [isEnd, setIsEnd] = useState("green");
  const [isEnd2, setIsEnd2] = useState("green");
  const [timeLeft, setTimeLeft] = useState(() => {
    const now = new Date();
    const start = new Date(startTimeON);
    const end = new Date(endTimeON);
    if (now < start) return { time: start - now, message: "starts in" };
    if (now <= end) return { time: end - now, message: "ends in" };
    return { time: 0, message: "Offer Expired" };
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const timeData = calculateTimeLeft();
      setTimeLeft(timeData);

      if (timeData.message === "ends in") {
        setIsEnd("red");
      } else {
        setIsEnd("green");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeData = calculateTimeLeft();
    setIsEnd2(timeData.message);
    if (timeData.message === "ends in") {
      setIsEnd("red");
    } else {
      setIsEnd("green");
    }
  }, [timeLeft]);

  function calculateTimeLeft() {
    const now = new Date();
    const start = new Date(startTimeON);
    const end = new Date(endTimeON);

    if (now < start) {
      return { time: start - now, message: "starts in" };
    } else if (now >= start && now <= end) {
      return { time: end - now, message: "ends in" };
    } else {
      return { time: 0, message: "Offer Expired" };
    }
  }

  function formatTimeLeft(milliseconds) {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { days, hours, minutes, seconds };
  }

  const time = formatTimeLeft(timeLeft.time);

  return (
    <>
      {user?.joinedContests?.includes(contestId) ? (

        isEnd2 === "starts in" ? (
          <div className="flex justify-between items-center gap-3 mt-4">
            <button className="flex-1 flex py-3 justify-center items-center gap-2 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/30 font-bold">
              Active Plan <ArrowRight size={18} />
            </button>

            <div className="p-3 bg-white/5 rounded-xl hover:bg-white/10 cursor-pointer transition text-white">
              <Share2 size={20} />
            </div>
          </div>

        ) : isEnd2 === "ends in" && isContestSubmitted ? (

          <div className="flex justify-between items-center gap-3 mt-4 w-full">

            <Link
              to={"/dash/contest-result"}
              state={{ contestId }}
              className="flex-1"
            >
              <div className="flex py-3 justify-center items-center gap-2 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-bold">
                View Result <ArrowRight size={18} />
              </div>
            </Link>

            <div className="p-3 bg-white/5 rounded-xl hover:bg-white/10 cursor-pointer transition text-white">
              <Share2 size={20} />
            </div>

          </div>

        ) : isEnd2 === "ends in" ? (

          <div className="flex justify-between items-center gap-3 mt-4">

            <Link
              to={"/dash/contest-question"}
              state={{ contestId }}
              className="flex-1 flex py-3 justify-center items-center gap-2 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/30 font-bold"
            >
              Start Now <ArrowRight size={18} />
            </Link>

            <div className="p-3 bg-white/5 rounded-xl hover:bg-white/10 cursor-pointer transition text-white">
              <Share2 size={20} />
            </div>

          </div>

        ) : (

          <div className="flex justify-between items-center gap-3 mt-4 w-full">

            <Link
              to={"/dash/contest-winner"}
              state={{ contestId }}
              className="flex-1"
            >
              <div className="flex py-3 justify-center items-center gap-2 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-bold">
                View Report <ArrowRight size={18} />
              </div>
            </Link>

            <div className="p-3 bg-white/5 rounded-xl hover:bg-white/10 cursor-pointer transition text-white">
              <Share2 size={20} />
            </div>

          </div>

        )

      ) : (

        <div className="flex justify-between items-center gap-3 mt-4 p-1">

          {isEnd2 === "Offer Expired" ? (
            <div className="flex-1 flex py-3 justify-center items-center gap-2 rounded-xl bg-gray-600/50 text-gray-400 cursor-not-allowed border border-white/5">
              <span className="font-bold">Contest Closed</span>
            </div>
          ) : (
            <button
              onClick={() => handleContestPayments(contestId)}
              className="flex-1 flex py-3 justify-center items-center gap-2 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold"
            >
              Join Now <ArrowRight size={18} />
            </button>
          )}

          <div className="p-3 bg-white/5 rounded-xl hover:bg-white/10 cursor-pointer transition text-white">
            <Share2 size={20} />
          </div>

        </div>

      )}
    </>
  );
}
export default ContestButton;
